import { SearchBaseModel } from '../commonModels';

export class ServiceSearchModel extends SearchBaseModel {

  constructor() {
      super();
      this.ServiceTypeId = null;
      this.IsActive = null;
      this.Name = null;
      this.IsDefinePrice = null;
      this.IsArticleRelation = null;
      this.IsOnlyForAdmin = null;
      this.GarageId = null;
      this.CustomerId = null;
      this.CarTypeId = null;
      this.ContractId = null;
      this.IsSystemOnly = null;
    }

    public ServiceTypeId: number;
    public IsActive: boolean;
    public Name: string;
    public IsDefinePrice: boolean;
    public IsArticleRelation: boolean;
    public IsOnlyForAdmin: boolean;
    public GarageId: number;
    public CustomerId: number;
    public CarTypeId: number;
    public ContractId: number;
    public IsSystemOnly: boolean;
    public SpecificationId: number;
}
